import * as XLSX from "xlsx";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";

export const ExportButton = ({ fileName = "reservation_list", list = [] }) => {
  const [filteredDataList, setFilteredDataList] = useState([]);
  const exportToExcel = () => {
    const excludeColumns = [
      "lastModifiedDate",
      "lastModifiedBy",
      "userId",
      "reservationSettingsId",
      "createdBy",
    ];
    const filteredData = filteredDataList.map((data) => {
      const filteredDataItem = {};
      Object.keys(data).forEach((key) => {
        if (!excludeColumns.includes(key)) {
          filteredDataItem[key] = data[key];
        }
      });
      return filteredDataItem;
    });
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(filteredData);
    XLSX.utils.book_append_sheet(wb, ws, "Reservations");
    XLSX.writeFile(wb, `${fileName}_${new Date().toLocaleString()}.xlsx`);
  };
  useEffect(() => {
    if (list) setFilteredDataList(list);
  }, [list]);

  return <Button onClick={exportToExcel}>EXPORT</Button>;
};
